import { FormNodeAccountModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class LoginEditor extends AbstractElementEditor<FormNodeAccountModel> {
  public getDescription(): string {
    return 'Allows logging in / registering a persistent account';
  }

  public getName(): string {
    return 'Account Element';
  }

  public getIcon(): string {
    return 'login';
  }
}
